module.exports = __webpack_public_path__ + "static/media/profile-placeholder.8a59e6a0.svg";